import { GQLError } from '../apis/graphql/graphqlAPI';
import admanToast from '../components/Alert/util/admanToast';

export type Error = {
  message: string;
};

export const getErrorMessages = (error: Error): string[] | undefined => {
  try {
    const errors = JSON.parse(error?.message) as GQLError;

    if (error) {
      if (Array.isArray(errors?.details)) {
        const errorsMap = errors.details.map(({ issue }) => issue).filter((error) => !!error);

        if (errorsMap?.length > 0) return errorsMap;
      }

      if (errors.message) return [errors.message];

      return errors.details.map(({ issue }) => issue);
    }
  } catch (e) {
    console.error('Cannot parse Error: ', error);
  }
};

export const getErrorsAsString = (error: Error): string => {
  const errorMessages = getErrorMessages(error);

  return errorMessages ? errorMessages.join('. ') : '';
};

const handleError = (error: Error): void => {
  const errorMessages = getErrorMessages(error) || [];

  errorMessages.forEach((errorMessage) => {
    admanToast.error(errorMessage);
  });
};

export default handleError;
